import { ICONS } from '@ui/icons/types';
import { DestinationTypeEnum } from '@/types/greenroom/destination.types';
import { ChannelType } from '@/types/channel.types';

export type DestinationTypeOption = {
  value: DestinationTypeEnum;
  label: string;
  icon: string;
};

export const getDefaultDestinationOption = (channelType?: ChannelType): DestinationTypeOption => {
  if (channelType === ChannelType.Webinar) {
    return { value: DestinationTypeEnum.Streams, label: 'Webinar+', icon: ICONS.WEBINAR_LOGO };
  }
  return { value: DestinationTypeEnum.Streams, label: 'BrandTV', icon: ICONS.BTV_LOGO };
};

export const DESTINATION_TYPE_OPTIONS: DestinationTypeOption[] = [
  { value: DestinationTypeEnum.Studio, label: 'Studio', icon: ICONS.STUDIO },
  { value: DestinationTypeEnum.Facebook, label: 'Facebook', icon: ICONS.FACEBOOK },
  { value: DestinationTypeEnum.YouTube, label: 'YouTube', icon: ICONS.YOUTUBE },
  { value: DestinationTypeEnum.Vimeo, label: 'Vimeo', icon: ICONS.VIMEO },
  { value: DestinationTypeEnum.LinkedIn, label: 'LinkedIn', icon: ICONS.LINKEDIN },
  { value: DestinationTypeEnum.Microsoft, label: 'Microsoft Teams', icon: ICONS.MS_TEAMS },
  { value: DestinationTypeEnum.Zoom, label: 'Zoom', icon: ICONS.ZOOM },
  { value: DestinationTypeEnum.Other, label: 'Other', icon: ICONS.LIVE_SIGNAL },
];

/* Only need to add destination names that require custom display names */
const destinationDisplayNameMapping: Record<string, string> = {
  [ChannelType.BrandTV]: 'BrandTV',
};
export const getDestinationDisplayNameMapping = (name?: string, fallback?: string): string | undefined => {
  if (!name) return fallback;
  return destinationDisplayNameMapping[name] ?? name;
};
